import React, { useEffect, useState } from "react";
import {
  defaultBorders,
  defaultLayouts,
  defaultPadding,
  defaultTypography,
  GSEmptyList,
  GSInput,
  GSItemList,
  GSSidePanelPage,
} from "golfstatus_react_components";
import {
  faChevronLeft,
  faSearch,
  faTimesCircle,
  faUserCircle,
} from "@fortawesome/free-solid-svg-icons";
import { useMatch } from "react-router-dom";

//import scss
import "./tournament-tv-leaderbaords-settings.scss";
import { useNotificationBanner } from "../../../../hooks/notificationHooks";
import { useDispatch, useSelector } from "react-redux";
import {
  eventBaseRoute,
  getProp,
  TOURNAMENT_ID,
} from "../../../../routes/event";
import {
  getNotificationItemInfo,
  getRouting,
} from "../../../../helpers/Converters";
import {
  getLeaderboards,
  selectLeaderboards,
  selectTVLeaderboards,
  setTVLeaderboards,
} from "../../../../reducers/leaderboardSlice";
import PageHeader from "../../../page-header";
import { useTheme } from "../../../../hooks/themeHooks";
import { useTournament } from "../../../../hooks/tournamentHooks";
import { getDateTimeOn } from "../../../../helpers/Dates";
import { navigateToLogin } from "../cart/user-checkout-info";
import { selectLoggedInUser } from "../../../../reducers/appSlice";
import { useGolfstatusNavigate } from "../../../../hooks/navigationHooks";

//Name the component
const TournamentTVLeaderboardSettings = (props) => {
  
  const notifications = [];
  const tournament = useTournament();

  const dispatch = useDispatch();

  const leaderboards = useSelector(selectLeaderboards);
  const selectedLeaderboards = useSelector(selectTVLeaderboards);

  const [, theme, getStyle] = useTheme();

  const [search, setSearch] = useState("");

  const loggedInUser = useSelector(selectLoggedInUser);

  const route = getRouting(eventBaseRoute, [
    TOURNAMENT_ID,
    "leaderboards",
    "tv",
    "settings",
  ]);
  const match = useMatch(route);
  const tournamentID = getProp(match?.params, TOURNAMENT_ID);

  const navigate = useGolfstatusNavigate(getRouting(eventBaseRoute, [tournamentID, "leaderboards", "tv"]));

  useEffect(() => {
    dispatch(getLeaderboards(tournamentID));
  }, [tournamentID, dispatch]);

  const getDrawerActions = () => {
    let actions = [{ name: "done", action: leftNavigation, type: "grey" }];
    return actions;
  };

  const leftNavigation = () => {
    navigate(getRouting(eventBaseRoute, [tournamentID, "leaderboards", "tv"]));
  };

  const getNavigation = () => {
    //Add Title to your component
    return {
      title: `TV Leaderboards`,
      leftIcon: faChevronLeft,
      leftButtonClick: leftNavigation,
    };
  };

  const selectLeaderboard = (option) => {
    const leaderboard = {...option, style: {}}
    if (leaderboardSelected(leaderboard)) {
      dispatch(
        setTVLeaderboards(
          selectedLeaderboards.filter?.((l) => l.id !== leaderboard.id)
        )
      );
    } else {
      dispatch(setTVLeaderboards([...selectedLeaderboards, leaderboard]));
    }
  };

  const leaderboardSelected = (leaderboard) => {
    return selectedLeaderboards?.some?.((l) => l.id === leaderboard.id);
  };

  const getFilteredList = () => {
    return leaderboards
      ?.filter?.((l) => {
        return l?.name?.toLowerCase?.()?.includes?.(search.toLowerCase());
      })
      ?.map?.((item) => {
        return {
          ...item,
          style: {
            borderWidth: "4px",
            borderStyle: "solid",
            ...defaultPadding.xLargePad,
            ...defaultBorders.mediumLargeBorderRadius,
            ...getStyle(theme.outlineVariant),
          },
        };
      });
  };

  const getEmptyList = () => {
    if (search !== "") {
      return (
        <GSEmptyList
          style={{ ...defaultPadding.emptyListPad, ...defaultLayouts.fill }}
          title="We could not fine the leaderboards you are looking for..."
          detail={`Leaderboards will become available just before the tournament starts${
            tournament?.startAt
              ? ` at ${getDateTimeOn(tournament?.startAt)}`
              : ""
          }`}
          actions={[
            {
              title: "View Event Details",
              type: "grey",
              onClick: () => {
                navigate(getRouting(eventBaseRoute, [tournament?.publicUrl]));
              },
            },
          ]}
        />
      );
    }
    return (
      <GSEmptyList
        style={{ ...defaultPadding.emptyListPad, ...defaultLayouts.fill }}
        title="No Leaderboards Yet"
        detail={`Leaderboards will become available just before the tournament starts${
          tournament?.startAt ? ` at ${getDateTimeOn(tournament?.startAt)}` : ""
        }.`}
        actions={[
          {
            title: "View Event Details",
            type: "grey",
            onClick: () => {
              navigate(getRouting(eventBaseRoute, [tournament?.publicUrl]));
            },
          },
        ]}
      />
    );
  };

  const getContent = () => {
    return (
      <gs-form>
        <PageHeader header="TV Leaderboards" />
        <div
          style={{
            ...defaultPadding.xLargePad,
            ...defaultLayouts.vStack,
            ...defaultLayouts.fullWidth,
            borderBottom: "1px solid",
            ...getStyle(theme.outlineVariant),
            display: "none",
          }}
        >
          <GSInput
            textValue={search}
            onChange={(e) => setSearch(e.target.value)}
            rightIconClick={() => {
              setSearch("");
            }}
            leftIcon={faSearch}
            rightIcon={faTimesCircle}
            placeholder="Search leaderboards..."
          />
        </div>

        {getFilteredList().length === 0 ? (
          getEmptyList()
        ) : (
          <GSItemList
            style={{
              ...defaultLayouts.fullWidth,
              ...defaultPadding.smallLayoutPad.apply("vertical"),
              ...defaultPadding.xLargePad.apply("horizontal"),
            }}
            type="vertical medium-large-gap"
            items={getFilteredList()}
            itemSelected={(leaderboard) => {
              selectLeaderboard(leaderboard);
            }}
            isCheckList={true}
            // checkAll={() => {
            //   dispatch(setTVLeaderboards(getFilteredList()));
            // }}
            // unCheckAll={() => {
            //   dispatch(setTVLeaderboards([]));
            // }}
            selectedItems={selectedLeaderboards ?? []}
            listItem={(leaderboard) => (
              <div
                style={{
                  ...defaultLayouts.vStack.align("flex-start", "flex-start"),
                  ...defaultLayouts.fullWidth,
                  ...defaultTypography.body,
                  ...defaultPadding.mediumLargePad.apply("horizontal")
                }}
              >
                <div style={{ ...defaultLayouts.fullWidth }}>
                  {leaderboard.name}
                </div>
                <div style={{ ...defaultLayouts.fullWidth, ...defaultTypography.bodyRegular.withOpacity(), ...defaultTypography.capitalize }}>
                  {leaderboard.privacy}
                </div>
              </div>
            )}
          />
        )}
      </gs-form>
    );
  };

  const timeoutAction = () => {};

  const getDrawer = () => {
    return {
      actions: getDrawerActions(),
    };
  };

  const notificationSettings = {
    notifications,
    timeoutAction,
    defaultBanner: loggedInUser?.id ? false:  {
      title: getNotificationItemInfo(
        `You're only seeing public leaderboards. Sign in to access all leaderboards`,
        faUserCircle
      ),
      bannerActions:  [
        {
          title: "Sign In",
          type: "grey no-wrap",
          onClick: () => {
            navigateToLogin();
          },
        },
      ],
      state: "grey",
    },
  };

  const [banner] = useNotificationBanner(notificationSettings);

  return (
    //name the component tag
    <tournament-tv-leaderbaords-settings>
      <GSSidePanelPage
        header={getNavigation()}
        banner={banner}
        content={getContent()}
        drawer={getDrawer()}
      ></GSSidePanelPage>
    </tournament-tv-leaderbaords-settings>
  );
};

//export the new namet
export default TournamentTVLeaderboardSettings;
